// extracted by mini-css-extract-plugin
export default {"profile":"profile_profile__nhd3c","f48":"profile_f48__WHVFa"};